import { FormGroup } from '@angular/forms';

import {
  DiscussionCreateRequest,
  DiscussionManagee,
  DiscussionRepetitionFrequency,
  DiscussionType,
} from '../discussion.models';
import { CreateDiscussionForm } from '../form/create-discussion-form.model';

export class CreateDiscussionDto implements DiscussionCreateRequest {
  title!: string;
  description!: string;
  managerUserId!: string;
  periodStartDate!: Date;
  periodEndDate!: Date;
  createTodos!: boolean;
  repeat!: DiscussionRepetitionFrequency;
  type!: DiscussionType;
  managees!: DiscussionManagee[];
  canEvaluateSelf!: boolean;
  canEvaluateManager!: boolean;
  holdingMeeting!: boolean;
  revealAnswersPriorToMeeting!: boolean;
  shouldSendEmailNotifications!: boolean;

  constructor(form: FormGroup<CreateDiscussionForm>) {
    Object.assign(this, {
      title: form.controls.title.value ?? '',
      description: form.controls.description.value ?? '',
      managerUserId: form.controls.managerId.value ?? '',
      periodStartDate: new Date(form.controls.periodStartDate.value ?? new Date()),
      periodEndDate: new Date(form.controls.periodEndDate.value ?? new Date()),
      createTodos: form.controls.createTodos.value ?? false,
      repeat: form.controls.repeat.value ?? DiscussionRepetitionFrequency.none,
      type: DiscussionType.quarterly,
      managees: [
        {
          seatHolderId: form.value.manageeSeatHolderId ?? '',
          userId: form.value.manageeId ?? '',
          dueDate: form.value.dueDate ? new Date(form.value.dueDate) : new Date(),
        },
      ],
      canEvaluateSelf: form.controls.canEvaluateSelf.value ?? true,
      canEvaluateManager: form.controls.canEvaluateManager.value ?? true,
      holdingMeeting: form.controls.holdingMeeting.value ?? true,
      revealAnswersPriorToMeeting: form.controls.revealAnswersPriorToMeeting.value ?? true,
      shouldSendEmailNotifications: true,
    });
  }
}
